<div class="first-column">
  <div class="mat-headline-5">{{ "ONSIP_I18N.DEFAULT_CALLER_ID" | translate }}</div>
  <p class="m-b-20">
    {{ "ONSIP_I18N.CALLER_ID_AUTOMATICALLY_APPLIES_TO_NEWLY_CREATED_USERS" | translate }}
  </p>
  <p class="m-b-20">
    It may be overridden on an individual user basis on the
    <a [routerLink]="views.USERS" class="link">users page</a>
    under the ‘Call settings’ tab.
  </p>
</div>
<onsip-loading-container [deferCond]="isDataObtained$">
  @if (organization$ | async) { @if ((callerIdPanel$ | async) === 'view') {
  <onsip-default-caller-id-view
    [organization]="(organization$ | async)!"
    (editPanel)="togglePanel('edit')"
  ></onsip-default-caller-id-view>
  } @if ((callerIdPanel$ | async) === 'edit') {
  <onsip-default-caller-id-edit
    [organization]="(organization$ | async)!"
    (editPanel)="togglePanel('view')"
  ></onsip-default-caller-id-edit>
  } }
</onsip-loading-container>
<div class="mat-body-2 contact-support">
  {{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
  <a class="support-link" [routerLink]="[views.CONTACT_SUPPORT]">
    {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
  </a>
</div>
